export default __webpack_public_path__ + "static/media/WebLogistian.710cb197.jpg";